// extracted by mini-css-extract-plugin
export default {"tabWrap":"Tab_tabWrap__fM9wz","tabWrapInner":"Tab_tabWrapInner__FIFgp","tab":"Tab_tab__3Apuz","tabActive":"Tab_tabActive__u+Ki4"};